import { useStoreState } from "ezStore";
import { intl } from "LocaleWrapper";
import { Select, SelectProps } from "@cofano/cck";
import { Fields, hasOptionalFieldPermission, hasPluginPermission } from "imports/Utils";
import { StatusActualTimeType, StatusType } from "__generated__/enums";

const StatusActualTimeSelect = ({ value, onChange, type }: Omit<SelectProps<StatusActualTimeType, false>, "fetchOptions"> & { type: StatusType }) => {

	const session = useStoreState(state => state.session);

	const options = [ {
		id: StatusActualTimeType.NotRequired,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_0" }),
		enabled: true,
	}, {
		id: StatusActualTimeType.Ata,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_1" }),
		enabled: type === StatusType.Call && hasOptionalFieldPermission(session, Fields.CALL, "actualTime"),
	}, {
		id: StatusActualTimeType.Atd,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_2" }),
		enabled: type === StatusType.Call && hasOptionalFieldPermission(session, Fields.CALL, "actualTime"),
	}, {
		id: StatusActualTimeType.Atso,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_3" }),
		enabled: type === StatusType.Call && hasOptionalFieldPermission(session, Fields.CALL, "startOperationTimes"),
	}, {
		id: StatusActualTimeType.Ateo,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_4" }),
		enabled: type === StatusType.Call && hasOptionalFieldPermission(session, Fields.CALL, "startOperationTimes"),
	}, {
		id: StatusActualTimeType.Nomination,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_5" }),
		enabled: type === StatusType.Voyage &&
			(hasPluginPermission(session, "nominationCustomer") || hasPluginPermission(session, "nominationShip")),
	}, {
		id: StatusActualTimeType.Override,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_6" }),
		enabled: true,
	}, {
		id: StatusActualTimeType.Atn,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_7" }),
		enabled: type === StatusType.Call && hasOptionalFieldPermission(session, Fields.CALL, "notificationTime"),
	}, {
		id: StatusActualTimeType.Dtn,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_8" }),
		enabled: type === StatusType.Call && hasOptionalFieldPermission(session, Fields.CALL, "notificationTime"),
	}, {
		id: StatusActualTimeType.RequiredForSkipper,
		name: intl.formatMessage({ id: "STATUS_TIMESTAMP_TYPE_9" }),
		enabled: true,
	} ];

	return (
		<Select
			disableSearch
			clearable={false}
			fetchOptions={[ ...options ].filter(option => option.enabled)}
			value={options.find(option => option.id === value)}
			onChange={(option) => onChange?.(option?.id ?? null, false)} />
	);
};

export default StatusActualTimeSelect;
